const LOCAL_STORAGE_KEYS = {
    /**
     * session assigned after a successful login
     */
    token: 'token',
    user: 'user',
    /**
     * User preferred language, default lan is en
     */
    userPreferedLanguage: 'userPreferedLanguage',
    /**
     * exit game after 5s  
     */
    exitGame: 'exitGame',
};

export default LOCAL_STORAGE_KEYS;
